/**
 * AccountSignIn.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { GUEST_LOGIN_ALLOWED_PATH } from '../constants';

const propTypes = {
    toggleSignInModalOpen: PropTypes.func,
    toggleCreateModalOpen: PropTypes.func,
    toggleSignInGuestModalOpen: PropTypes.func
};

export default class AccountSignIn extends React.Component {
    render() {
        const signInFn = GUEST_LOGIN_ALLOWED_PATH.test(window.location.pathname)
            ? 'toggleSignInGuestModalOpen'
            : 'toggleSignInModalOpen';

        return (
            <div className="nav-user-sign-in">
                <button
                    className="nav-header-button"
                    aria-label="Sign Up"
                    onClick={() => this.props.toggleCreateModalOpen()}>
                    Sign Up
                </button>

                <button
                    className="nav-header-button"
                    aria-label="Log In"
                    onClick={() => this.props[signInFn]()}>
                    Log In
                </button>
            </div>
        );
    }
}

AccountSignIn.propTypes = propTypes;
